export default {
  state: {
    travelData: {},
  },

  getters: {
    getTravelData(state) {
      return state.travelData;
    },
  },

  mutations: {
    setTravelData(state, data) {
      const isNull = data === null;

      state.travelData = {
        id: !isNull ? +data.id : "",
        trip_date: !isNull ? data.trip_date : "",
        trip_hour: !isNull ? data.trip_hour : "",
        trip_id: !isNull ? +data.trip_id : "",
        trip_name: !isNull ? data.trip_name : "",
        license_plate: !isNull ? data.license_plate : "",
        type: !isNull ? data.type : "",
        driver: !isNull ? data.driver : "",
        deleted_at: !isNull ? data.deleted_at : null,
        vancancies: !isNull ? data.vancancies : "",
        companions_cpf: !isNull ? data.companions_cpf : [],
      };
    },
  },

  actions: {
    changeTravelData(context, data) {
      context.commit("setTravelData", data);
    },
  },
};
